import { render } from "./ForgotPasswordResetForm.vue?vue&type=template&id=5d3c64fa"
import script from "./ForgotPasswordResetForm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ForgotPasswordResetForm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script